// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPopup_root__hi8zt","logo":"FullPopup_logo__a2i8g","header":"FullPopup_header__FK-le","close":"FullPopup_close__3qM9N","bgGreen":"FullPopup_bgGreen__yXCyu"};